import { GrowthBook } from "@growthbook/growthbook-react";

const apiHost =
  import.meta.env.VITE_GROWTHBOOK_API_HOST || "https://cdn.growthbook.io";
const clientKey = import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY || "";

export const growthbook = new GrowthBook({
  apiHost,
  clientKey,
  enableDevMode: import.meta.env.DEV,
  attributes: {
    env: import.meta.env.VITE_ENV || import.meta.env.MODE,
  },
});

export const initGrowthBook = async () => {
  if (!clientKey) {
    return false;
  }

  try {
    await growthbook.init({
      streaming: true,
      timeout: 3000,
    });
    return true;
  } catch {
    return false;
  }
};

export const setGrowthBookUserAttributes = (user) => {
  if (!user) {
    growthbook.setAttributes({
      env: import.meta.env.VITE_ENV || import.meta.env.MODE,
    });
    return;
  }

  growthbook.setAttributes({
    env: import.meta.env.VITE_ENV || import.meta.env.MODE,
    id: user.id != null ? String(user.id) : undefined,
    email: user.email,
    supplierId: user.supplier_id,
    supplierGroupId: user.supplier_group_id,
    supplierLocationId: user.supplier_location_id,
    roleId: user.role_id,
    admin: !!user.admin || !!user.isSuperAdmin,
  });
};
